import axios from 'axios'
import qs from 'qs'
import router from '../router/'
import env from '../config/'

const baseURL = env.apiLink

// 创建axios实例
const service = axios.create({
  baseURL,
  timeout: 50000, // 请求超时时间
  headers: {
    'lang-type': 'zh-CN'
  }
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // if(config.method === 'post'){
    // 	config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // }else if(config.method === 'get'){
    // 	config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // }
    if (localStorage.getItem('token')) {
      let access = JSON.parse(localStorage.getItem('token'))
      // config.headers['	Authorization'] = `Bearer ${localStorage.getItem('token')}`
      config.headers['accessToken'] = access.accessToken
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// response拦截器
service.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    console.log(err)
    // axios接口服务器无法连接
    if (err.code) {
      if (err.code == 'ERR_NETWORK' || err.code == 'ECONNABORTED') {
        this.$message.error('网络错误，无法与服务器建立通信')
        // console.log(router.push({ path: '/service-error.html' }))
      }
    }
    if (err.response.data.status == 403) {
      // TOKEN校验失败，进行重新登录
      localStorage.setItem('token', '')
      localStorage.setItem('rePath', router.history.current.path)
      localStorage.setItem('query', JSON.stringify(router.history.current.query))
      router.replace({ path: '/login' })
    }
    return Promise.reject(err)
  }
)

export default service

/**
 * get 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}) {
  let header = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
  return new Promise((resolve, reject) => {
    service
      .get(url, { params }, header)
      .then((res) => {
        console.log(res)
        if (res.status == 600 || res.status == 602 || res.status == 403) {
          // TOKEN校验失败，进行重新登录
          localStorage.setItem('token', '')
          localStorage.setItem('rePath', router.history.current.path)
          localStorage.setItem('query', JSON.stringify(router.history.current.query))
          router.replace({ path: '/login' })
          window.location.replace(window.location.origin + '/authorization')

          // reject(res)
        } else if (res.status == 602) {
          // TOKEN已经过期，获取最新Token，重新重新请求
          reject(res)
        } else if (res.status == 406) {
          reject(res) // 该栏目尚未初始化，请联系管理员
          router.push({ path: '/406.html' })
        } else {
          console.log('本次请求：', url)
          console.log('本次参数：', params)
          console.log('返回结果：', res)
          resolve(res.data)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, isJson = false) {
  let params = isJson ? JSON.stringify(data) : qs.stringify(data)
  let header = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }

  return new Promise((resolve, reject) => {
    service.post(url, params, header).then(
      (res) => {
        resolve(res)
      },
      (err) => {
        resolve({ data: JSON.parse(err.request.response) })
      }
    )
  })
}

/**
 * put 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}, isJson = false) {
  return new Promise((resolve, reject) => {
    let params = isJson ? JSON.stringify(data) : qs.stringify(data)
    let header = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    service.put(url, params, header).then(
      (res) => {
        resolve(res)
        console.log('本次请求：', url)
        console.log('本次参数：', params)
        console.log('返回结果：', res)
      },
      (err) => {
        resolve({ data: JSON.parse(err.request.response) })
      }
    )
  })
}

/**
 * delete 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 * @constructor
 */
export function Delete(url, params = {}) {
  return new Promise((resolve, reject) => {
    let header = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    service.delete(url, { params }, header).then(
      (res) => {
        resolve(res)
        console.log('本次请求：', url)
        console.log('本次参数：', params)
        console.log('返回结果：', res)
      },
      (err) => {
        reject(err)
      }
    )
  })
}

/**
 * 上传文件
 * @param url
 * @param data
 * @returns {Promise}
 */
export function upload(url, data = {}) {
  let header = { headers: { 'Content-Type': 'multipart/form-data' } }
  return new Promise((resolve, reject) => {
    service.post(url, data, header).then(
      (res) => {
        resolve(res)
        console.log('本次请求：', url)
        console.log('本次参数：', data)
        console.log('返回结果：', res)
      },
      (err) => {
        reject(err)
      }
    )
  })
}
